import {
  Page,
  Document,
  PDFViewer,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: "30px 40px",
    fontSize: 9,
    fontFamily: "Helvetica",
  },
  title: {
    fontSize: 12,
    textAlign: "center",
    marginTop: 60,
    marginBottom: 50,
    fontWeight: "bold",
    color: "#696969",
  },
  datos: {
    marginBottom: 10,
    marginHorizontal: 40,
  },
  introText: {
    marginTop: 10,
    lineHeight: 0.8,
  },
  table: {
    marginTop: 0,
    borderTop: 0.5,
    borderLeft: 0.5,
    borderColor: "#808080",
    borderStyle: "solid",
    width: 510.1, 
    alignSelf: "center",
  },
  tableRowHeader: {
    flexDirection: "row",
    backgroundColor: "#d9d9d9",
  },
  cellHeader: {
    borderRight: 0.5,
    borderBottom: 0.5,
    borderColor: "#808080",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  headerText: {
    fontSize: 8,
    fontWeight: "bold",
    textAlign: "center",
  },
  subCellHeader: {
    borderRight: 0.5,
    borderBottom: 0.5,
    borderColor: "#808080",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f2f2f2",
  },
  tableRow: {
    flexDirection: "row",
  },
  cellRow: {
    borderRight: 0.5,
    borderBottom: 0.5,
    borderColor: "#808080",
    justifyContent: "center",
    minHeight: 15,
  },
  rowText: {
    textAlign: "center",
    fontSize: 7.5, 
  },
  legalSection: {
    marginTop: 10,
    marginHorizontal: 40,
    fontSize: 8.5,
    lineHeight: 1.4,
    textAlign: "left",
  },
  signatureSection: {
    marginTop: 40,
    marginHorizontal: 40,
    gap: 18,
  },
  signatureLine: {
    fontSize: 10,
  },
  creationDate: {
    fontSize: 7.5,
    marginTop: 3,
  }
});

function ProofDeliveryDocument({ procedure, documentData }) {
  const MyDoc = () => {
    const currentDate = new Date().toLocaleDateString("es-BO", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    const parsedDocumentData = documentData.map((item) =>
      JSON.parse(item.description)
    );

    return (
      <Document>
        <Page size="LETTER" style={styles.page}>
          
          <Text style={styles.title}>Constancia de Entrega de Documentos</Text>

          <View style={styles.datos}>
            <Text>Señor (a):</Text>
            <Text style={{ fontWeight: "bold", fontSize: 10, marginTop: 2 }}>
              {procedure?.companyName}
            </Text>
            <Text style={styles.introText}>
              En primer lugar, gracias por el gusto y la confianza prestada en nuestra compañía. A continuación, le damos a conocer los documentos que se le está entregando en <Text style={{fontWeight: "bold"}}>FÍSICO.</Text>
            </Text>
          </View>

          {/* TABLA CENTRADA */}
          <View style={styles.table}>
            <View style={styles.tableRowHeader}>
              <View style={{ ...styles.cellHeader, width: 113.6, height: 40 }}><Text style={styles.headerText}>DESCRIPCION</Text></View>
              <View style={{ ...styles.cellHeader, width: 85.55, height: 40 }}><Text style={styles.headerText}>NUMERO</Text></View>
              <View style={{ ...styles.cellHeader, width: 85.55, height: 40 }}><Text style={styles.headerText}>CANTIDAD</Text></View>
              
              <View style={{ width: 113.6, flexDirection: "column" }}>
                <View style={{ ...styles.cellHeader, width: 113.6, height: 20 }}><Text style={styles.headerText}>DEPARTAMENTO</Text></View>
                <View style={{ flexDirection: "row", height: 20 }}>
                  <View style={{ ...styles.subCellHeader, width: 56.8 }}><Text style={{fontSize: 6}}>CONTABILIDAD</Text></View>
                  <View style={{ ...styles.subCellHeader, width: 56.8 }}><Text style={{fontSize: 6}}>COMERCIAL</Text></View>
                </View>
              </View>

              <View style={{ width: 111.8, flexDirection: "column" }}>
                <View style={{ ...styles.cellHeader, width: 111.8, height: 20 }}><Text style={{fontSize: 7, fontWeight:'bold'}}>ESTADO DE DOCUMENTO</Text></View>
                <View style={{ flexDirection: "row", height: 20 }}>
                  <View style={{ ...styles.subCellHeader, width: 28.2 }}><Text style={{fontSize: 6}}>ORG</Text></View>
                  <View style={{ ...styles.subCellHeader, width: 28.2 }}><Text style={{fontSize: 6}}>LEG</Text></View>
                  <View style={{ ...styles.subCellHeader, width: 28.2 }}><Text style={{fontSize: 5}}>ELEC. ORG.</Text></View>
                  <View style={{ ...styles.subCellHeader, width: 27.2 }}><Text style={{fontSize: 5, textAlign:'center'}}>FOTOC.{"\n"}OPIA</Text></View>
                </View>
              </View>
            </View>

            {parsedDocumentData.map((item, index) => (
              // <View key={index} style={{ ...styles.tableRow, backgroundColor: index % 2 === 0 ? "#fff" : "#f0f0f0" }}>
              <View key={index} style={{ ...styles.tableRow, backgroundColor: "#fff"}}>
                <View style={{ ...styles.cellRow, width: 113.6 }}>
                   <Text style={{ ...styles.rowText, textAlign: 'left', paddingLeft: 4 }}>{item?.descripcion || ""}</Text>
                </View>
                <View style={{ ...styles.cellRow, width: 85.55 }}><Text style={styles.rowText}>{item?.numero || ""}</Text></View>
                <View style={{ ...styles.cellRow, width: 85.55 }}><Text style={styles.rowText}>{item?.cantidad || ""}</Text></View>
                <View style={{ ...styles.cellRow, width: 56.8 }}><Text style={styles.rowText}>{item?.contabilidad || ""}</Text></View>
                <View style={{ ...styles.cellRow, width: 56.8 }}><Text style={styles.rowText}>{item?.comercial || ""}</Text></View>
                <View style={{ ...styles.cellRow, width: 28.2 }}><Text style={styles.rowText}>{item?.org || ""}</Text></View>
                <View style={{ ...styles.cellRow, width: 28.2 }}><Text style={styles.rowText}>{item?.leg || ""}</Text></View>
                <View style={{ ...styles.cellRow, width: 28.2 }}><Text style={styles.rowText}>{item?.elecOrg || ""}</Text></View>
                <View style={{ ...styles.cellRow, width: 27.2 }}><Text style={styles.rowText}>{item?.fotocopia || ""}</Text></View>
              </View>
            ))}
          </View>

          <View style={{ borderBottom: 0.5, borderLeft: 0.5, borderRight: 0.5, borderColor: "#808080", padding: 5, width: 510.1, alignSelf: "center" }}>
            <Text style={{ textAlign: "center", fontSize: 10 }}>Adjuntamos fotocopias de documentos que acompañan al trámite</Text>
          </View>

          <View style={styles.legalSection}>
            <Text>
              La documentación soporte del despacho Aduanero, se encuentra detallada en la página de documentos adicionales de la declaración de mercancías (DIM) {" "}
              <Text style={{ textDecoration: "underline", fontStyle: "italic" }}>
                de acuerdo al artículo 45° inciso e) de la ley general de Aduanas N° 1990 se encuentra bajo nuestra custodia.
              </Text>
            </Text>
          </View>

          <View style={styles.signatureSection}>
            <Text style={styles.signatureLine}>Firma: ................................................................</Text>
            <Text style={styles.signatureLine}>Recibido por: ......................................................</Text>
            <View>
              <Text style={styles.signatureLine}>Fecha: ................................................................</Text>
              <Text style={styles.creationDate}>Elaborado en fecha {currentDate}</Text>
            </View>
          </View>

        </Page>
      </Document>
    );
  };

  return (
    <div>
      {documentData && (
        <PDFViewer style={{ width: 900, height: window.innerHeight - 100 }}>
          <MyDoc />
        </PDFViewer>
      )}
    </div>
  );
}

export default ProofDeliveryDocument;